<div style="display: inline-block;">
    <h4>device</h4>
    <video id="device" controls autoplay></video>
</div>
